import styled from "styled-components";

const StyledList = styled.div`
  ul {
    li {
      padding: 10px 0 30px;
      font-family: "supply", monospace;
      font-size: 13px;
      line-height: 16px;
      color: ${({ theme }) => theme.colours.lightGrey};
      border-top: 1px solid ${({ theme }) => theme.colours.lightGrey};
      p strong {
        font-family: ${({ theme }) => theme.fontFamily};
        text-transform: uppercase;
        display: inline-block;
        width: 60px;
        margin-right: 20px;
        letter-spacing: 1px;
        color: ${({ theme }) => theme.colours.lightGrey};
      }
      p i > strong,
      p strong > i {
        color: ${({ theme }) => theme.colours.gold};
      }
    }
  }
  @media (${({ theme, $columnsAt = "xl" }) => theme.mq[$columnsAt]}) {
    ul {
      columns: 2;
      column-gap: 40px;
      li {
        display: flex;
        break-inside: avoid;
        strong {
          white-space: nowrap;
        }
      }
    }
  }
`;

export default StyledList;
